import { render, staticRenderFns } from "./HeaderBoxInfo.vue?vue&type=template&id=a0208e2e&"
import script from "./HeaderBoxInfo.vue?vue&type=script&lang=js&"
export * from "./HeaderBoxInfo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBoxInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports